import { endpoints } from '@/api/endpoints.ts'
import { axiosAPI } from '@/api/repository/repository.ts'
import { LoginResponse } from '@/model/login-response.ts'
import { User } from '@/model/user.ts'

class AuthRepository {
  async me (): Promise<User> {
    console.log('GET me...')
    const response = await axiosAPI.get(`${endpoints.auth}/me`)
    return User.fromJson(response.data)
  }

  async loginWithGoogle (googleToken: string): Promise<LoginResponse> {
    console.log('login with google...')
    const response = await axiosAPI.post<LoginResponse>(
      `${endpoints.auth}/google`,
      {
        token: googleToken,
      },
    )

    return LoginResponse.fromJson(response.data)
  }
}

export const authRepository = new AuthRepository()
